import { IconSearch } from "@tabler/icons-react";
import type * as React from "react";
import type { InputProps } from "@/components/ui/input";
import { InputGroup, InputGroupAddon, InputGroupInput } from "@/components/ui/input-group";
import { cn } from "@/lib/utils";

interface SearchInputProps extends Omit<InputProps, "size" | "style" | "type"> {
  showIcon?: boolean;
  textSize?: "compact" | "default";
}

/** Paper search control shared by table toolbars. Width remains a layout concern. */
export function SearchInput({
  showIcon = false,
  textSize = "default",
  className,
  placeholder,
  "aria-label": ariaLabel,
  ...props
}: SearchInputProps): React.ReactElement {
  return (
    <InputGroup
      className={cn(
        "h-8 rounded-[8px] border-line bg-surface text-[11px] shadow-none before:hidden [&_input]:text-[11px] [&_input]:leading-[14px] sm:text-[11px]",
        textSize === "compact" && "text-[10px] [&_input]:text-[10px] sm:text-[10px]",
        className,
      )}
    >
      <InputGroupInput
        type="search"
        size="sm"
        style={{
          lineHeight: "14px",
          paddingLeft: showIcon ? "7px" : "10px",
          paddingRight: "10px",
        }}
        aria-label={ariaLabel ?? placeholder}
        placeholder={placeholder}
        {...props}
      />
      {showIcon ? (
        <InputGroupAddon align="inline-start" className="text-ink [&_svg]:mx-0 [&_svg]:opacity-100">
          <IconSearch style={{ width: 13, height: 13 }} />
        </InputGroupAddon>
      ) : null}
    </InputGroup>
  );
}
